const styles = theme => ({
    container:{
      // height: 75,
    },
    panel: {
        backgroundColor: '#f3f3f3',
        padding: '15px 15px 0 15px',
    },
    logoRow: {
        margin: '10px 10px 10px',
        alignItems: 'center'
    },
    logoCol: {
        padding: '0 10px',
        margin: '0 15px',
        maxWidth: 39,
    },
    logo: {

        maxWidth: 39,
        maxHeight: 39,
        marginRight: 4,
        objectFit: 'cover',
        textAlign: 'center',
        borderRadius: '50%',
    },
    row: {
    },
    col: {
        padding: '0 10px',
        margin: '10px 15px'
    },
    checkboxRow: {
        margin: '10px 15px'
    },
    label:{
        textAlign: 'left',
        fontFamily: 'AvenirNext',
        fontSize: '10px',
        fontWeight: 500,
        color: '#96979a',
        marginBottom: '5px',
        textTransform: 'uppercase'
    }
});

export default styles;